import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { generateFieldJSXCore } from './generate-field-jsx-core.js'
import { generateIconPostfix } from './generate-icon-postfix.js'

export function generateFieldJSX(
  field: SchemaField,
  indent = '          ',
  context: FieldRenderContext = {}
): string {
  if (field.hidden) return ''
  if (context.slotFilter && (field.slot ?? 'main') !== context.slotFilter) return ''

  const mainJSX = generateFieldJSXCore(field, indent, context)
  if (!mainJSX) return ''

  if (field.hasIcon && !['group', 'section', 'tabs', 'separator'].includes(field.type)) {
    return `${mainJSX}\n${generateIconPostfix(field, indent)}`
  }

  return mainJSX
}
